export function isNullishOrEmpty(value: Array<any> | ReadonlyArray<any> | string | number | null | undefined): value is [] | '' | null | undefined {
	return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);
}
